import React, { useState } from "react";

export default function LimitAndCharge() {
  const [selectedOption, setSelectedOption] = useState("Limit");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCardType, setSelectedCardType] = useState("");

  const currencies = ["USD", "EUR", "NGN"];
  const cardTypes = ["MasterCard", "Visa", "Verve"];

  return (
    <div className="gateway-settings-tab">
      <div className="limit-charge-container">
        <div className="select-section">
          <div className="select-wrapper">
            <label htmlFor="currency">Currency</label>
            <select
              id="currency"
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="" disabled>
                Select Currency
              </option>
              {currencies.map((currency) => (
                <option key={currency} value={currency}>
                  {currency}
                </option>
              ))}
            </select>
          </div>
          <div className="select-wrapper">
            <label htmlFor="cardType">Card Type</label>
            <select
              id="cardType"
              value={selectedCardType}
              onChange={(e) => setSelectedCardType(e.target.value)}
            >
              <option value="" disabled>
                Select Card Type
              </option>
              {cardTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div className="select-wrapper">
            <label htmlFor="option">Choose Option</label>
            <select
              id="option"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="Limit">Limit</option>
              <option value="Charge">Charge</option>
            </select>
          </div>
        </div>

        {/* Conditional Rendering for Limit or Charge */}
        {selectedOption === "Limit" ? (
          <div className="limit-section">
            <h5>Limit Configuration</h5>
            <div className="input-row">
              <div className="input-group">
                <label>Hourly Limit</label>
                <input type="number" placeholder="Enter hourly limit" />
              </div>
              <div className="input-group">
                <label>Daily Limit</label>
                <input type="number" placeholder="Enter daily limit" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Weekly Limit</label>
                <input type="number" placeholder="Enter weekly limit" />
              </div>
              <div className="input-group">
                <label>Monthly Limit</label>
                <input type="number" placeholder="Enter monthly limit" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Minimum Amount</label>
                <input type="number" placeholder="Enter minimum amount" />
              </div>
              <div className="input-group">
                <label>Maximum Amount</label>
                <input type="number" placeholder="Enter maximum amount" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Total Amount Per Day</label>
                <input type="number" placeholder="Enter total amount per day" />
              </div>
              <div className="input-group">
                <label>Total Amount Per Week</label>
                <input
                  type="number"
                  placeholder="Enter total amount per week"
                />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Total Amount Per Month</label>
                <input
                  type="number"
                  placeholder="Enter total amount per month"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="charge-section">
            <h5>Charge Configuration</h5>
            <div className="input-row">
              <div className="input-group">
                <label>Processing Currency</label>
                <input type="text" placeholder="Enter processing currency" />
              </div>
              <div className="input-group">
                <label>Settlement Currency</label>
                <input type="text" placeholder="Enter settlement currency" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Transaction Fee</label>
                <input type="number" placeholder="Enter transaction fee" />
              </div>
              <div className="input-group">
                <label>Refund Fee</label>
                <input type="number" placeholder="Enter refund fee" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Chargeback Fee</label>
                <input type="number" placeholder="Enter chargeback fee" />
              </div>
              <div className="input-group">
                <label>Settlement Fee</label>
                <input type="number" placeholder="Enter settlement fee" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Annual Fee</label>
                <input type="number" placeholder="Enter annual fee" />
              </div>
              <div className="input-group">
                <label>Payment Period</label>
                <input type="text" placeholder="Enter payment period" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Minimum Payout</label>
                <input type="number" placeholder="Enter minimum payout" />
              </div>
              <div className="input-group">
                <label>Rolling Reserve</label>
                <input type="number" placeholder="Enter rolling reserve" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Rolling Period (in days)</label>
                <input
                  type="number"
                  placeholder="Enter rolling period in days"
                />
              </div>
              <div className="input-group">
                <label>Settlement Batch</label>
                <input type="text" placeholder="Enter settlement batch" />
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Amount Unit</label>
                <input type="text" placeholder="Enter amount unit" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
